import React, { useRef, useState } from "react";
import { Button, Col, FormGroup, Input, Label, Row } from "reactstrap";
import { IField } from "../../shared/model/field.model";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { IOption } from "../../shared/model/option.model";
import {
  MAX_SIZE_ALLOWED,
  MAX_SIZE_ALLOWED_MB,
} from "../../shared/constants/contants";

interface IProps {
  formik: any;
  field: IField;
  indexField: number;
  errors: number[];
}
interface IErrorFile {
  state: boolean;
  text: string;
  reason: string;
}
const initialError: IErrorFile = {
  state: false,
  text: "",
  reason: "",
};

export const InputAttached = (props: IProps) => {
  const { field, formik, indexField } = props;
  const fileRef = useRef<HTMLInputElement>(null);
  const [errorLoad, setErrorLoad] = useState<IErrorFile>(initialError);

  const handleClickFile = (e: any) => {
    e.preventDefault();
    // await formik.setTouched({ ...formik.touched, file: true }, true);
    fileRef?.current?.click();
  };
  const handleClickRemoveFile = (ind: number) => {
    formik.setFieldValue(
      `resourceToInstance.resource.fields[${indexField}].options[${ind}].response`,
      ""
    );
    formik.setFieldValue(
      `resourceToInstance.resource.fields[${indexField}].options[${ind}].attachedFile`,
      ""
    );
    if (fileRef.current) {
      fileRef.current.value = "";
    }
  };
  const handleFileChange = (e: any, ind: number) => {
    if (e.target.files && e.target.files[0].size > MAX_SIZE_ALLOWED) {
      setErrorLoad({
        state: true,
        text: `Error, el archivo supera los ${MAX_SIZE_ALLOWED_MB} MB`,
        reason: "size",
      });
      formik.setFieldValue(`${e.target.name}.response`, "");
      formik.setFieldValue(`${e.target.name}.attachedFile`, "");
    } else {
      setErrorLoad({
        state: false,
        text: "",
        reason: "",
      });
      formik.setFieldValue(`${e.target.name}.response`, e.target.files[0].name);
      formik.setFieldValue(`${e.target.name}.attachedFile`, e.target.files[0]);
    }
  };

  return (
    <FormGroup>
      <Label>
        <h4>{field.name}</h4>
        <p>{field.description}</p>
      </Label>

      {field.options &&
        field.options.map((option: IOption, indOp: number) => (
          <div key={indOp}>
            {formik.values?.resourceToInstance?.resource?.fields[indexField]
              ?.options[indOp]?.attachedFile ? (
              <>
                <Row>
                  <Col md={6} className="d-flex input-file-custom">
                    <Input
                      name={`resourceToInstance.resource.fields[${indexField}].options[${indOp}].response`}
                      type="text"
                      readOnly
                      value={
                        formik.values?.resourceToInstance?.resource?.fields[
                          indexField
                        ]?.options[indOp]?.response || ""
                      }
                    />
                    {formik.values?.resourceToInstance?.resource?.fields[
                      indexField
                    ]?.options[indOp]?.response !== "" && (
                      <a onClick={() => handleClickRemoveFile(indOp)}>
                        <span className="d-md-inline text-danger icon-delete-file">
                          <FontAwesomeIcon icon={faTimesCircle} />
                        </span>
                      </a>
                    )}
                  </Col>
                </Row>
              </>
            ) : (
              <>
                <Row>
                  <Col className="d-flex justify-content-end align-items-end">
                    <Button
                      className="btn-link-card"
                      outline
                      onClick={handleClickFile}
                    >
                      Agregar archivo
                    </Button>
                  </Col>
                  <input
                    type="file"
                    name={`resourceToInstance.resource.fields[${indexField}].options[${indOp}]`}
                    ref={fileRef}
                    onChange={(e) => handleFileChange(e, indOp)}
                    hidden
                  />
                </Row>
                {errorLoad && errorLoad.state && (
                  <Row className="mt-3">
                    <Col>
                      <div className="text-danger">{errorLoad.text}</div>
                    </Col>
                  </Row>
                )}
              </>
            )}
          </div>
        ))}
      {props.errors.length > 0 &&
        field?.id &&
        props.errors.indexOf(field.id) >= 0 && (
          <div className="invalid-field">Este campo es obligatorio</div>
        )}
    </FormGroup>
  );
};
